// extracted by mini-css-extract-plugin
module.exports = {"list":"FooterList_list___fXXB","title":"FooterList_title__98QrT"};